import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';

export interface IEmploymentTaxesDetailsAddEditValidated {
    birthDate: Date | null;
    city: string | null;
    country: string | null;
    houseNumber: string | null;
    houseNumberSuffix: string | null;
    identifierSocialSecurity: string | null;
    isNaturalPerson: boolean;
    street: string | null;
    zip: string | null;
}

export const employmentTaxesDetailsAddEditSchema: ISchemaContainer<IEmploymentTaxesDetailsAddEditValidated> = {
    schema: Koi.when(Koi.ref('.isNaturalPerson'), {
        is: true,
        otherwise: Koi.object({
            birthDate: Koi.koi().date().valid(null),
            city: Koi.string().valid(null),
            country: Koi.string().valid(null),
            houseNumber: Koi.string().valid(null),
            houseNumberSuffix: Koi.string().valid(null),
            identifierSocialSecurity: Koi.string().valid(null),
            isNaturalPerson: Koi.boolean().valid(false),
            street: Koi.string().valid(null),
            zip: Koi.string().valid(null),
        }),
        then: Koi.object({
            birthDate: Koi.koi().date().required(),
            city: Koi.string().max(255).required(),
            country: Koi.string().max(255).required(),
            houseNumber: Koi.string().max(255).required(),
            houseNumberSuffix: Koi.string().max(255).allow('', null),
            identifierSocialSecurity: Koi.string().elfproef().required(),
            isNaturalPerson: Koi.boolean().valid(true),
            street: Koi.string().max(255).required(),
            zip: Koi.string().max(255).when('country', {
                is: 'NL',
                then: Koi.string().zipCodeNL(),
            }),
        }),
    }).options({ convert: false, presence: 'required' }),
};
